import { render, staticRenderFns } from "./SelectMultiple.vue?vue&type=template&id=5b6545da&scoped=true&"
import script from "./SelectMultiple.vue?vue&type=script&lang=js&"
export * from "./SelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./SelectMultiple.vue?vue&type=style&index=0&id=5b6545da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6545da",
  null
  
)

export default component.exports